import { render, staticRenderFns } from "./MapCluster.vue?vue&type=template&id=13cc28f2&"
import script from "./MapCluster.vue?vue&type=script&lang=js&"
export * from "./MapCluster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MapCluster.vue"
export default component.exports